import {
  ICON_DOMAIN, useNotifications,
} from '@doveit/bricks';
import React, { FunctionComponent, useState } from 'react';
import { getNextColdLeadContact, getNextLeadContact } from '../../../providers/api/call-center/callCenterLeadProvider';
import WelcomeBox from '../../../components/welcome-box/WelcomeBox';
import { CallContextType, ProcessableContact } from '../../../providers/api/dtos';
import { useContactToProcessCount } from '../../hooks/use-contact-to-process-count/useContactToProcessCount';

export const LOAD_ERROR_MESSAGE = 'Impossibile caricare i dati: ricarica la pagina e riprova.';
export const START_ERROR_MESSAGE = 'Errore durante il caricamento del prossimo contatto: riprova più tardi.';

export interface StartLeadProcessProps {
  onNextContact: (processableContact?: ProcessableContact) => void,
  coldLead?: boolean,
}

const StartLeadProcess: FunctionComponent<StartLeadProcessProps> = ({
  onNextContact,
  coldLead = false,
}) => {
  const [isStarting, setIsStarting] = useState(false);
  const {
    data: callCenterContactCount, isLoading: isContactCountLoading, mutate: mutateCallCenterContactCount, error: contactCountError,
  } = useContactToProcessCount(coldLead ? CallContextType.COLD_LEAD : CallContextType.LEAD);
  const { addError } = useNotifications();

  const startProcessLead = React.useCallback(async () => {
    setIsStarting(true);

    try {
      const processableContact = coldLead
        ? await getNextColdLeadContact()
        : await getNextLeadContact();
      setIsStarting(false);

      onNextContact(processableContact);
    } catch (err) {
      setIsStarting(false);

      addError(START_ERROR_MESSAGE);
    }
  }, [addError, coldLead, onNextContact]);

  return (
    <WelcomeBox
      icon={ICON_DOMAIN}
      label={coldLead ? 'lead fredde' : 'lead'}
      loading={isStarting}
      count={callCenterContactCount?.count}
      onStartClick={startProcessLead}
      onRefreshClick={mutateCallCenterContactCount}
      isContactCountError={!!contactCountError}
      isContactCountLoading={isContactCountLoading}
    />
  );
};

export default StartLeadProcess;
